/**
 * Main JavaScript for Shopify Theme
 */

(function () {
  "use strict";

  /**
   * Mobile Menu Toggle
   */
  function initMobileMenu() {
    const toggle = document.querySelector(".header__mobile-toggle");
    const nav = document.querySelector(".header__nav");

    if (!toggle || !nav) return;

    toggle.addEventListener("click", function () {
      const isExpanded = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", !isExpanded);
      nav.classList.toggle("is-open");
      document.body.classList.toggle("menu-open");
    });
  }

  /**
   * Product Variant Selector
   */
  function initVariantSelector() {
    const selects = document.querySelectorAll(".main-product__option-select");
    const variantSelect = document.querySelector(
      ".main-product__variant-select",
    );

    if (!selects.length || !variantSelect) return;

    selects.forEach((select) => {
      select.addEventListener("change", function () {
        const options = Array.from(selects).map((s) => s.value);
        const variantOptions = Array.from(variantSelect.options);

        const matchingVariant = variantOptions.find((option) => {
          const variantTitle = option.textContent.split(" - ")[0].trim();
          return options.every((opt) => variantTitle.includes(opt));
        });

        if (matchingVariant) {
          variantSelect.value = matchingVariant.value;
          updatePrice(matchingVariant.textContent);
        }
      });
    });
  }

  /**
   * Product Image Gallery
   */
  function initProductGallery() {
    const thumbnails = document.querySelectorAll(".main-product__thumbnail");
    const mainImage = document.querySelector(".main-product__image-main img");

    if (!thumbnails.length || !mainImage) return;

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", function () {
        thumbnails.forEach((t) => t.classList.remove("is-active"));
        this.classList.add("is-active");

        const newSrc = this.querySelector("img").src.replace("100x", "800x");
        mainImage.src = newSrc;
      });
    });
  }

  /**
   * Cart Quantity Update
   */
  function initCartQuantity() {
    const quantityInputs = document.querySelectorAll(
      ".main-cart__quantity-input",
    );

    quantityInputs.forEach((input) => {
      input.addEventListener("change", function () {
        const line = this.dataset.line;
        const quantity = this.value;

        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            line: parseInt(line),
            quantity: parseInt(quantity),
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (quantity === "0") {
              location.reload();
            }
            updateCartCount(data.item_count);
          })
          .catch((error) => console.error("Error:", error));
      });
    });
  }

  /**
   * Update Cart Count
   */
  function updateCartCount(count) {
    const cartCount = document.querySelector(".navbar__cart-count");
    if (cartCount) {
      cartCount.textContent = count;
    }
  }

  /**
   * Collection Sort
   */
  function initCollectionSort() {
    const sortSelect = document.querySelector(".main-collection__sort-select");

    if (!sortSelect) return;

    sortSelect.addEventListener("change", function () {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", this.value);
      window.location.href = url.toString();
    });
  }

  /**
   * Add to Cart AJAX
   */
  function initAddToCart() {
    const forms = document.querySelectorAll(".main-product__form");

    forms.forEach((form) => {
      form.addEventListener("submit", function (e) {
        e.preventDefault();

        const formData = new FormData(this);
        const button = this.querySelector(".main-product__add-to-cart");
        const originalText = button.textContent;

        button.disabled = true;
        button.textContent = "Adding...";

        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            button.textContent = "Added!";
            updateCartCount(data.items ? data.items.length : 1);

            setTimeout(() => {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          })
          .catch((error) => {
            console.error("Error:", error);
            button.textContent = "Error";

            setTimeout(() => {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          });
      });
    });
  }

  /**
   * Newsletter Form
   */
  function initNewsletter() {
    const forms = document.querySelectorAll(".footer__newsletter-form");

    forms.forEach((form) => {
      form.addEventListener("submit", function (e) {
        const button = this.querySelector(".footer__newsletter-button");
        const input = this.querySelector(".footer__newsletter-input");

        if (!input.value) {
          e.preventDefault();
          input.focus();
        }
      });
    });
  }

  /**
   * Sticky Header
   */
  function initStickyHeader() {
    const header = document.querySelector(".header");
    if (!header || header._scrollBound) return;
    header._scrollBound = true;

    const onScroll = () => {
      header.classList.toggle("is-scrolled", window.pageYOffset > 100);
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    document.addEventListener("shopify:section:unload", function cleanup(e) {
      if (e.target.contains(header)) {
        window.removeEventListener("scroll", onScroll);
        document.removeEventListener("shopify:section:unload", cleanup);
        header._scrollBound = false;
      }
    });
  }

  /**
   * Product Recommendations
   */
  function initProductRecommendations() {
    const section = document.querySelector(".product-recommendations");
    if (!section) return;

    const url = section.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(".product-recommendations");

        if (recommendations && recommendations.innerHTML.trim()) {
          section.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((error) => console.error("Error loading recommendations:", error));
  }

  /**
   * Initialize all modules
   */
  function init() {
    initMobileMenu();
    initVariantSelector();
    initProductGallery();
    initCartQuantity();
    initCollectionSort();
    initAddToCart();
    initNewsletter();
    initStickyHeader();
    initProductRecommendations();
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
